import { Component, ReactNode } from "react"

import ErrorPage from "@src/components/ui/ErrorPage"

interface ErrorBoundaryProps {
  children: ReactNode
  fallback?: ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
  error: Error | null
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = {
      hasError: false,
      error: null,
    }
  }

  static getDerivedStateFromError(_: Error): ErrorBoundaryState {
    return { hasError: true, error: new Error(_.message) }
  }

  // componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
  // }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <ErrorPage
            title="An error occurred"
            description={this.state.error?.message || "Oops something went wrong!"}
            code={"😢"}
            primary={{ label: "Reload", onClick: () => window.location.reload() }}
          />
        )
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
